/**
 * Prefix for the names of offers created by the admin gift-impact flow.
 *
 * Admin gift offers are reusable, single-impact-type offer definitions named
 * deterministically as `${ADMIN_GIFT_OFFER_PREFIX}${type}-${amount}`
 * (e.g. `admin-gift-tree-whole-5`). The prefix scopes find-or-create lookups so
 * the gift flow never reuses a genuine promotional offer that happens to grant
 * the same impact amounts.
 */
export const ADMIN_GIFT_OFFER_PREFIX = "admin-gift-";

/**
 * The impact-type tokens an admin gift can grant, mapped to the corresponding
 * `OfferEntity` amount column. The token mirrors the canonical `optionsConfig`
 * identifier (underscores swapped for hyphens) and keeps the unit so it stays
 * unambiguous against the dormant `co2e50Kg` column.
 */
export const ADMIN_GIFT_IMPACT_COLUMNS = {
  "tree-whole": "wholeTrees",
  "co2e-100kg": "co2e100Kg",
  "plastic-100g": "plastic100g",
} as const;

export type AdminGiftImpactType = keyof typeof ADMIN_GIFT_IMPACT_COLUMNS;

export const adminGiftImpactTypes = Object.keys(
  ADMIN_GIFT_IMPACT_COLUMNS,
) as AdminGiftImpactType[];
